import {memo} from 'react';
import {Video} from '~library/atoms/Video';

// Prevents react from re-rendering the video bg when moving from one asset editor to another
export const VideoBackground = memo(({selectedBackground}) => {
  if (!selectedBackground?.src || !selectedBackground?.isVideo) {
    return null;
  }

  return (
    <Video
      src={selectedBackground.src}
      className="event-create-design__background"
      reload
      options={{
        id: selectedBackground?.id,
      }}
    />
  );
});
